import _ from 'lodash';

const createLoadingSelector = actions => state => {
  return _(actions).some(action => _.get(state, `loading.${action}`));
};

export default createLoadingSelector;
